/**
 * Rastgele kimlik uretici.
 *
 * ## Neden `crypto.randomUUID()` DOGRUDAN cagrilamiyor
 *
 * `crypto.randomUUID` YALNIZCA guvenli baglamda (`https:` veya `localhost`)
 * tanimli. Bu kurulum duz HTTP uzerinden bir ana bilgisayar adiyla servis
 * ediliyor (`http://hedefai.local:8080`, `http://192.168.0.166:8080`) ve orada
 * fonksiyon **yok** - cagirmak `TypeError` firlatiyor.
 *
 * Bu gercek bir arizaydi ve tam olarak soyle gorunuyordu: mesaj gonderilmiyor,
 * arayuz "Mesaj gonderilemedi." diyor ve sunucu logunda ISTEK HIC YOK - cunku
 * hata `fetch`ten ONCE, istemci tarafinda firliyor. Uc sebep birlestigi icin
 * uzun sure gorunmez kaldi:
 *
 *   * `127.0.0.1` guvenli baglam SAYILIYOR, yani localhost'tan yapilan her
 *     dogrulama calisiyor;
 *   * jsdom `randomUUID`i sagliyor, yani vitest de goremiyor;
 *   * mevcut testler ustune bir de kendi stub'ini kuruyordu.
 *
 * Kod tabanindaki diger tum guvenli-baglam API'leri KORUMALI
 * (`navigator.clipboard?.`, `navigator.mediaDevices?.`, `navigator.locks`
 * fallback'i, `'serviceWorker' in navigator`); korumasiz olan tek yer buydu.
 *
 * ## Neden `Math.random` fallback'i YOK
 *
 * Uretilen deger `client_message_id` olarak gidiyor ve sunucuda
 * `UNIQUE(conversation_id, client_message_id)` var - yani bir CAKISMA, yeni
 * bir mesajin eski bir mesajin tekrari sayilip SESSIZCE dusurulmesi demek.
 * `Math.random` bunun icin yeterince guclu degil.
 *
 * Buna gerek de yok: `crypto.getRandomValues` guvenli baglam GEREKTIRMIYOR
 * (guvenli baglam kavramindan onceye dayaniyor) ve her yerde var. Kisitli olan
 * yalnizca `randomUUID` sarmalayicisi.
 */

/** RFC 4122 sürüm 4 UUID. */
export function randomId(): string {
  // Guvenli baglamda tarayicinin kendi uygulamasi kullanilsin.
  if (typeof crypto.randomUUID === 'function') return crypto.randomUUID()

  const bytes = crypto.getRandomValues(new Uint8Array(16))
  // Surum (4) ve varyant (10xx) bitleri: uretilen dize gercekten v4 olmali,
  // yoksa "UUID gibi gorunen" bir sey uretmis olurduk.
  bytes[6] = (bytes[6] & 0x0f) | 0x40
  bytes[8] = (bytes[8] & 0x3f) | 0x80

  const hex: string[] = []
  for (const byte of bytes) hex.push(byte.toString(16).padStart(2, '0'))
  return [
    hex.slice(0, 4).join(''),
    hex.slice(4, 6).join(''),
    hex.slice(6, 8).join(''),
    hex.slice(8, 10).join(''),
    hex.slice(10, 16).join(''),
  ].join('-')
}
